<div class="mct-flex mct-col mct-gap-27"  >
  <div class="mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-between mct-items-center"   >
    <span class="section-header">{{ 'committees.edit.committee-members.title' | translate | titlecase }}</span>
    <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10"   >
      <button
        *wlAccessControl="{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 2 }"
        class="atlas-btn atlas-btn-primary mct-flex mct-row mct-justify-center mct-items-center"
        
        
        (click)="memberEditDialog.open()"
      >
        <i class="pi pi-plus"></i>
        <span>{{ 'committees.edit.committee-members.add-a-member' | translate | uppercase }}</span>
      </button>
      <button
        *wlAccessControl="{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 2 }"
        class="atlas-btn atlas-btn-primary mct-flex mct-row mct-justify-center mct-items-center"
        
        
        (click)="groupAddDialog.open()"
      >
        <i class="pi pi-plus"></i>
        <span>{{ 'committees.edit.committee-members.add-a-group-of-members' | translate | uppercase }}</span>
      </button>
    </div>
  </div>

  <wl-committee-members-search-params [(searchParams)]="searchParams"></wl-committee-members-search-params>

  <div class="mct-flex mct-row mct-justify-end mct-items-center"  >
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="searchGrid.search()">
      {{ 'committees.edit.committee-members.run-this-search' | translate | uppercase }}
    </button>
  </div>

  <wl-committee-members-search-grid #searchGrid [(searchParams)]="searchParams"></wl-committee-members-search-grid>
</div>

<wl-committee-member-edit-dialog
  #memberEditDialog
  [committeeId]="committeeId"
  (saved)="searchGrid.search()"
></wl-committee-member-edit-dialog>

<wl-committee-member-group-add-dialog
  #groupAddDialog
  [committeeId]="committeeId"
  (addedProfiles)="searchGrid.search()"
></wl-committee-member-group-add-dialog>
